import { NavLink } from 'react-router-dom';
import { Box, Breadcrumbs } from '@mantine/core';

export const TagsPageNavigation = () => {
    const breadcrumbs = [
        { title: 'Administration', href: '/administration' },
        { title: 'Tags Management' }
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));
    return <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>;
};

export const ContactsPageNavigation = () => {
    const breadcrumbs = [
        { title: 'Administration', href: '/administration' },
        { title: 'Contacts Overview' }
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));
    return <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>;
};

export const MessagesPageNavigation = () => {
    const breadcrumbs = [
        { title: 'Administration', href: '/administration' },
        { title: 'Messages Statistics' }
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));
    return <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>;
};
